import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiParameter,
    API_URL_CURRENT_FRAGMENT,
    get,
    HasPagingParameters,
    patch,
    post,
    request,
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { CustomerAttributeModel, CustomerRegistrationResponseModel, LoadCustomerDetailModel, NewCustomerModel } from "@TKCCP/Types/ApiModels";

export interface AddCustomerApiParameter extends ApiParameter {
    newCustomerModel: NewCustomerModel;
}

const customerUrl = "/api/v1/TKCCPCustomerRegistration";

export async function createCustomer(parameter: AddCustomerApiParameter): Promise<CustomerRegistrationResponseModel>{
    const billToId = parameter.newCustomerModel.billToModel?.id;
    let returnModel :any;
    if(billToId && (billToId!=="" ||  billToId!=null))
    {
        const updateModel = await patch<NewCustomerModel>(
            `${customerUrl}/${billToId}`,
            parameter.newCustomerModel,
        );
        returnModel=updateModel;
    }
    else{
        const shipTo = await post<NewCustomerModel,CustomerRegistrationResponseModel>(
            `${customerUrl}/addcustomerregistration`,
            parameter.newCustomerModel,
        );
        returnModel= shipTo
    }
       return returnModel;
}
export interface LoadCustomerDetailParameter extends ApiParameter {
    referenceNumber: string;
}

export interface GetCreateUserAccountParameter extends ApiParameter {
    referenceNumber: string;
}
export function getCustomerDetail(parameter: LoadCustomerDetailParameter): Promise<LoadCustomerDetailModel> {

    try {

        const getCustomerDetailModel = get<LoadCustomerDetailModel>(

            `/api/v1/TKCCPCustomerRegistration/${parameter.referenceNumber}`,

        );

        return getCustomerDetailModel;

    } catch (error) {

        if (isApiError(error) && error.status === 400) {

            // return {

            //     // successful: false,

            //     // errorMessage: error.errorJson.message,

            // };

        }

        throw error;

    }

}

export async function getCustomerAttributeList(): Promise<CustomerAttributeModel> {
    try {

        const result = await get<CustomerAttributeModel>(`api/v1/TKCCPCustomerRegistration/getCustomerAttribute`) as CustomerAttributeModel;
         return result;
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            // return {
            //     // successful: false,
            //     // errorMessage: error.errorJson.message,
            // };
        }
        throw error;
    }
}


